import { useContext } from 'react';
import { useLogger } from 'core/common/hooks';
import { FlowLayout } from 'core/common/ui/layouts';
import { FadeInWrapper } from 'core/common/ui/ui-kit';
import { SupportBotButton } from 'core/common/ui/widgets';
import { ScreenType } from 'core/flow/entities';
import { QuizContext } from 'core/funnel/contexts/FlowContext';
import { screenComponents } from './screenComponents';

type FlowScreensProps = {
  screenId: string;
};

export const FlowScreens = ({ screenId }: FlowScreensProps) => {
  const logger = useLogger();
  const { flowInitialScreenId, getScreenAttributes } = useContext(QuizContext);

  const screenAttributes = getScreenAttributes(screenId);

  if (!screenAttributes) return null;

  const nextScreenAttributes = screenAttributes.next
    ? getScreenAttributes(screenAttributes.next)
    : null;

  const getScreen = () => {
    // TODO: Temp cast before we use two types, after refactoring will leave only ScreenType
    const screenType = screenAttributes.screenType as ScreenType;

    if (!screenComponents[screenType]) {
      logger.error(new TypeError(`Unknown step data: ${JSON.stringify(screenType)}`));
      return null;
    }
    const { Screen } = screenComponents[screenType];

    return (
      <FadeInWrapper key={screenId}>
        <Screen screenId={screenId} />
      </FadeInWrapper>
    );
  };

  return (
    <FlowLayout
      screenId={screenId}
      initialScreenId={flowInitialScreenId}
      screenAttributes={screenAttributes}
      nextScreenAttributes={nextScreenAttributes}
    >
      {getScreen()}
      {screenAttributes.supportWidget && (
        <SupportBotButton variant="fixed" buttonText={screenAttributes.supportWidget.text} />
      )}
    </FlowLayout>
  );
};
